export const KINDS = { general: "Info umum", feature: "Fitur baru", update: "Update fitur", maintenance: "Maintenance" };
export const SEVERITY = {
  info: { label: "Info", banner: "bg-blue-50 border-blue-200 text-blue-900", dot: "bg-blue-500" },
  success: { label: "Sukses", banner: "bg-emerald-50 border-emerald-200 text-emerald-900", dot: "bg-emerald-500" },
  warning: { label: "Peringatan", banner: "bg-amber-50 border-amber-200 text-amber-900", dot: "bg-amber-500" },
  critical: { label: "Kritis", banner: "bg-red-50 border-red-200 text-red-900", dot: "bg-red-500" },
};
export const STATUS = {
  draft: "bg-slate-100 text-slate-600", scheduled: "bg-violet-50 text-violet-700",
  published: "bg-emerald-50 text-emerald-700", cancelled: "bg-red-50 text-red-600",
};
export const STATUS_LABEL = { draft: "Draft", scheduled: "Terjadwal", published: "Terbit", cancelled: "Dibatalkan" };

const pad = (n) => String(n).padStart(2, "0");
export const toLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const toUtc = (v) => (v ? new Date(v).toISOString().replace(".000Z", "+00:00") : null);
export const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const IN = "w-full rounded-xl border border-line bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-brand disabled:bg-slate-50";
